import API from '../api'
import deleteUrl from './paths'


export const deleteLead = (leadId) =>
    new Promise((resolve, reject) => {
        API.delete(deleteUrl.deleteLead, { leadId })
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })

export const deleteTaskReminder = (leadId, reminderId) =>
    new Promise((resolve, reject) => {
        API.delete(deleteUrl.deleteTaskReminder, { leadId, reminderId })
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })

export const deleteMeetingRemarks = (leadId, meetingId, updatedBy) =>
    new Promise((resolve, reject) => {
        API.delete(deleteUrl.deleteMeetingRemarks, { leadId, meetingId, updatedBy })
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })